import React from "react";
import { BrowserView, MobileView } from "react-device-detect";

import "./scss/style.scss";
import "./App.css";

import Header from "./views/common/Header";
import MobilePage from "./views/Home/page/MobilePage";
import Home from "./views/Home/page/Home";
import { ColorProvider } from "./util/ColorContext";

function App() {
  return (
    <>
      <ColorProvider>
        <MobileView>
          <Header />
          <MobilePage />
        </MobileView>

        <BrowserView>
          <Header />
          <Home />
        </BrowserView>
      </ColorProvider>
    </>
  );
}

export default App;
